<template>
  <v-carousel
    class="pa-0 ma-0"
  >
    <v-carousel-item
      v-for="(color, i) in colors"
      :key="color"
      class="pa-0 ma-0"
    >
      <v-sheet
        :color="color"
        height="100%"
        tile
      >
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        >
          <div class="display-3">
            Slide {{ i + 1 }}
          </div>
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'Slider',
  data() {
    return {
      colors: [
        'primary',
        'green',
        'yellow darken-2',
        'red',
        'orange',
      ],
    };
  },
};
</script>

<style scoped>

</style>
